interface ChatAvatarProps {
  type: 'user' | 'ai';
  userName?: string;
  userInitial?: string;
  className?: string;
}

/**
 * ChatAvatar - Avatar para mensagens do chat
 *
 * - User: Mostra inicial do nome do perfil
 * - AI (TAIS): Mostra logo do sideMenu
 */
export const ChatAvatar = ({ type, userName, userInitial, className = '' }: ChatAvatarProps) => {
  const isAI = type === 'ai';

  if (isAI) {
    return (
      <img
        src="/logo-tais.svg"
        alt="TAIS"
        className={`w-8 h-8 flex-shrink-0 ${className}`}
      />
    );
  }

  // Avatar do usuário: inicial do nome
  const initial = userInitial || (userName ? userName.charAt(0).toUpperCase() : 'U');

  return (
    <div
      className={`
        w-8 h-8 rounded-full bg-[#F4CC04]
        flex items-center justify-center flex-shrink-0
        text-black font-bold text-sm
        ${className}
      `}
    >
      {initial}
    </div>
  );
};
